import {createContext} from "react";

const IntakeContext = createContext({
  markAsChecked: () => console.warn("markAsChecked not provided"),
  fetchAccounts: () => console.warn("fetchAccounts not provided")
});

export default IntakeContext;

